export enum Pages {
  PaymentPage = '/payment-page',
  SchedulePayment = '/schedule',
  PaymentMethods = '/payment-methods',
  Error = '/error',
  ConfirmationPage = '/confirmation',
  PayByLink = '/pay-by-link',
  PayByLinkAuthentication = '/pay-by-link/:customerId/:requestId',
  UpdateEmail = '/update-email',
  EmbedTestParent = '/embed-test-parent/:manifestId',
  EmbedPayment = '/embed/:id',
}
